import topApi from '../../../components/api/ToPApi';

// Reporte de restaurante (reglas en el API: services/restaurant-report.ts)

export interface RestaurantReport {
    from: string;
    to: string;
    days: number;
    summary: {
        invoices: number;
        sales: number;
        averageTicket: number | null;
        guests: number;
        averagePerGuest: number | null;
        guestCoverage: number | null;
    };
    tables: { tableId: number; table: string; orders: number; turnsPerDay: number; averageMinutes: number | null; sales: number }[];
    kitchen: {
        tickets: number;
        average: number | null;
        p90: number | null;
        courses: { course: number; name: string; tickets: number; average: number | null; p90: number | null }[];
        slowest: { name: string; tickets: number; average: number }[];
    };
    bands: {
        key: string;
        name: string;
        hours: string;
        products: number;
        quantity: number;
        sales: number;
        top: BandProduct[];
        bottom: BandProduct[];
    }[];
}

export interface BandProduct {
    productId: number;
    name: string;
    quantity: number;
    total: number;
}

const errorMessage = (e: any) => e?.response?.data?.error || 'Ocurrió un error de comunicación, intente de nuevo.';

export const loadRestaurantReport = async (from: string, to: string): Promise<RestaurantReport> => {
    try {
        const resp = await topApi.get<RestaurantReport>('/reports/restaurant/', { params: { from, to } });
        return resp.data;
    } catch (e) {
        throw new Error(errorMessage(e));
    }
};

export const money = (value: number | null | undefined) =>
    value === null || value === undefined ? '—' : Number(value).toLocaleString('es-CR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const minutesText = (value: number | null | undefined) =>
    value === null || value === undefined ? '—' : `${Number(value).toLocaleString('es-CR', { maximumFractionDigits: 1 })} min`;

// Filas para exportar a CSV (una hoja por sección, juntas)
export const reportCsvRows = (r: RestaurantReport) => [
    { Sección: 'Resumen', Concepto: 'Facturas', Valor: r.summary.invoices },
    { Sección: 'Resumen', Concepto: 'Ventas', Valor: r.summary.sales.toFixed(2) },
    { Sección: 'Resumen', Concepto: 'Ticket promedio', Valor: r.summary.averageTicket?.toFixed(2) ?? '' },
    { Sección: 'Resumen', Concepto: 'Comensales', Valor: r.summary.guests },
    { Sección: 'Resumen', Concepto: 'Promedio por comensal', Valor: r.summary.averagePerGuest?.toFixed(2) ?? '' },
    ...r.tables.map(t => ({
        Sección: 'Mesas', Concepto: t.table,
        Valor: `${t.orders} órdenes · ${t.turnsPerDay} por día · ${t.averageMinutes ?? '-'} min · ${t.sales.toFixed(2)}`,
    })),
    ...r.kitchen.courses.map(c => ({
        Sección: 'Cocina', Concepto: c.name, Valor: `${c.tickets} comandas · promedio ${c.average ?? '-'} min · p90 ${c.p90 ?? '-'} min`,
    })),
    ...r.bands.flatMap(b => b.top.map((p, i) => ({
        Sección: `Más vendidos ${b.name}`, Concepto: `${i + 1}. ${p.name}`, Valor: `${p.quantity} · ${p.total.toFixed(2)}`,
    }))),
    ...r.bands.flatMap(b => b.bottom.map((p, i) => ({
        Sección: `Menos vendidos ${b.name}`, Concepto: `${i + 1}. ${p.name}`, Valor: `${p.quantity} · ${p.total.toFixed(2)}`,
    }))),
];
